import i18nInstance from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enUsJson from './en-US.json';

const Language = {
	'en-US': 'en-US'
};

void i18nInstance
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			[Language['en-US']]: {
				translations: enUsJson
			}
		},
		fallbackLng: Language['en-US'],
		debug: false,
		ns: ['translations'],
		defaultNS: 'translations',
		interpolation: {
			escapeValue: false,
			formatSeparator: ',',
			alwaysFormat: true,
			skipOnVariables: false
		},
		detection: {
			order: ['localStorage', 'navigator', 'cookie']
		},
		returnNull: false
	})
	.then(() => {
		i18nInstance.services.formatter?.add(
			'isNumber',
			(value: unknown, lng: string | undefined) =>
				new Intl.NumberFormat(lng).format(value as number)
		);
	});

export { i18nInstance as i18n };
